import React, { useEffect } from "react";


import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/routes";
import { buildAbsoluteFileUrl, publicContentApi } from "./api/api";



import "@fortawesome/fontawesome-free/css/all.min.css";

import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import "./App.css";






const App = () => {
  useEffect(() => {
    let isCancelled = false;
    const BRAND_TITLE_KEY = "app_brand_title";
    const BRAND_FAVICON_KEY = "app_brand_favicon";

    const applyTabBranding = ({ projectTitle, logoUrl }) => {
      const title = String(projectTitle || "").trim() || "خبرخوان";
      document.title = title;
      try {
        localStorage.setItem(BRAND_TITLE_KEY, title);
      } catch (error) {
        // Ignore storage errors.
      }

      if (!logoUrl) {
        return;
      }

      const href = buildAbsoluteFileUrl(logoUrl);
      if (!href) {
        return;
      }

      const faviconLinks = [
        document.querySelector("link[rel='icon']"),
        document.querySelector("link[rel='shortcut icon']"),
      ].filter(Boolean);

      if (faviconLinks.length === 0) {
        const fallbackFavicon = document.createElement("link");
        fallbackFavicon.setAttribute("rel", "icon");
        fallbackFavicon.setAttribute("href", href);
        document.head.appendChild(fallbackFavicon);
      } else {
        faviconLinks.forEach((linkNode) => {
          linkNode.setAttribute("href", href);
        });
      }
      try {
        localStorage.setItem(BRAND_FAVICON_KEY, href);
      } catch (error) {
        // Ignore storage errors.
      }
    };

    const fetchTabBranding = async () => {
      try {
        const result = await publicContentApi.getHomepageConfig();
        if (isCancelled) {
          return;
        }
        applyTabBranding({
          projectTitle: result?.project_title,
          logoUrl: result?.home_logo,
        });
      } catch (error) {
        applyTabBranding({ projectTitle: "خبرخوان", logoUrl: "" });
      }
    };

    fetchTabBranding();
    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <BrowserRouter>
      
      <div className="App">
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
};



export default App;
